<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>OFERTAS DE LICITACIÓN</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/familias']" class="nav-link m-1 pl-3 pr-3">Familias</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/calificacion']" class="nav-link m-1 pl-3 pr-3 ">Calificación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/ofertas-de-licitacion']" class="nav-link m-1 pl-3 pr-3 disabled" tabindex="-1" aria-disabled="true"> Ofertas de Licitación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/postulantes-ofertas']" class="nav-link m-1 pl-3 pr-3" tabindex="-1" aria-disabled="true"> Postulantes por oferta</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/consultas-reportes']" class="nav-link m-1 pl-3 pr-3 "> Consultas/Reportes </a>
                    </li> -->
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/login']" class="nav-link cerrar m-1 pl-3 pr-3 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row pb-5 mt-5">
            <div class="col-12 mb-1">
                <div class="row FlstLi mb-2">
                    <div class="col-6 col-md-6 col-lg-3 text-left my-2 ">
                        <button type="submit" class="mr-2" (click)="addOferta()"> Agregar Nueva Oferta</button>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mx-auto">
                <div class="FlstLi table-responsive">
                    <div class="row dDoce text-right pr-2 barIcon">
                        <div class="col-8 col-sm-8 col-md-3 col-lg-2 ml-auto barIconInt">
                            <div class="row dDoce mx-0">
                                <!-- <div class="col-12 ml-auto px-0">
                                    <a href="#" data-type="excel">
                                        <img class="ico-formulario iconClick" src="./../../../../../assets/images/icons/icono-descarga.svg" alt="Descarga">
                                    </a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <table class="Ftabla Ftablon table dDoce">
                        <tr>
                            <th scope="col" class="pl-2 pr-2">Código</th>
                            <th scope="col" class="pl-2 pr-2">Producto</th>
                            <th scope="col" class="pl-2 pr-2">Fecha de publicación</th>
                            <th scope="col" class="pl-2 pr-2">Familia</th>
                            <th scope="col" class="pl-2 pr-2">Activo</th>
                        </tr>
                        <tr></tr>
                        <tbody class="tablaBlq" *ngFor="let oferta of ofertas| paginate: { itemsPerPage: 4, currentPage: p }">
                            <tr>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.codigo}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.producto}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.fechaPublicacion | date: 'dd-MM-yyyy hh:mm'}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.familia}}</td>          
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.activo ? 'Si' : 'No'}}</td>
                            </tr>
                            <tr></tr>
                        </tbody>
                    </table>
                </div>
                <pagination-controls previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="p = $event"></pagination-controls>
            </div>
        </div>
      
        <div class="col-12 alerta-big blqCtr text-center" *ngIf="this.editar">
            <div class="row mb-2">
                <h4>Actualiza Oferta</h4>
            </div>
            <form  ngNativeValidate #Update="ngForm" (ngSubmit)="UpdateCalifo(Update)"  class="pb-3 row">
                <div class="row">
                    <div class="form-group col-12 col-md-12 col-lg-4 text-left">
                        <label for="codigoProductoUpdate" class="pt-2">Código</label>
                        <input [(ngModel)]="codigoProductoUpdate" name="codigoProductoUpdate" type="text" id="codigoProductoUpdate" maxlength="50" value="" required class="form-control">
                    </div>
                    <div class="form-group col-12 col-md-12 col-lg-8 text-left">
                        <label for="productoUpdate" class="pt-2">Producto</label>
                        <input [(ngModel)]="productoUpdate" name="productoUpdate" type="text" id="productoUpdate" maxlength="50" value="" required class="form-control">
                    </div>
                    <div class="form-group col-12 col-md-4 col-lg-4 text-left">
                        <label>Selecciona una familia</label>
                        <select [(ngModel)]="familiaUpdate" name="familiaUpdate" class="form-control" required>
                            <option *ngFor="let familia of familias" [ngValue]="familia.id"> {{ familia.familia }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md-4 col-lg-4 text-center">
                        <div class="mt-3">
                            <input [(ngModel)]="estatusUpdate" name="estatusUpdate" type="checkbox" id="estatusUpdate" class="form-check-input">
                            <label for="estatusUpdate" class="form-check-label">&nbsp;Activo</label>
                        </div>
                    </div>
                    <div class="form-group col-12 text-left">
                        <label for="mensajeTextAreaUpdate">Detalle de oferta:</label>
                        <textarea [(ngModel)]="mensajeTextAreaUpdate" name="mensajeTextAreaUpdate" name="mensajeTextAreaUpdate" class="form-control" placeholder=" " rows="6" style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px; resize: none;" required></textarea>
                    </div>
                    <div class="form-group col-12 text-left">
                        <label for="pdfProducto">Archivo PDF:</label>
                        <input type="file" accept="application/pdf" id="pdfProducto" class="form-control-file">
                    </div>
                    <div class="col-12">
                        <button type="submit" class="mr-2"> Actualizar </button>
                        <button class="ml-2 redBtn" (click)="cancel()"> Cancelar</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="col-12 alerta-big blqCtr text-center"  *ngIf="this.addd">
            <div class="row mb-2">
                <h4>Alta Nueva Califiacion</h4>
            </div>
            <form  #f="ngForm" (ngSubmit)="confirmacionAgregar(f)" ngNativeValidate class="pb-3 row">
                <div class="row">
                    <div class="form-group col-12 col-md-12 col-lg-4 text-left">
                        <label for="CodigoProducto" class="pt-2">Código</label>
                        <input ngModel="CodigoProducto" name="CodigoProducto" type="text" id="CodigoProducto" maxlength="50" value="" required class="form-control">
                    </div>
                    <div class="form-group col-12 col-md-12 col-lg-8 text-left">
                        <label for="Producto" class="pt-2">Producto</label>
                        <input ngModel="Producto" name="Producto" type="text" id="Producto" maxlength="50" value="" required class="form-control">
                    </div>
                    <div class="form-group col-12 col-md-6 text-left">
                        <label>Selecciona una familia</label>
                        <select ngModel="FamiliaId" name="FamiliaId" class="form-control" required>
                            <option *ngFor="let familia of familias" [ngValue]="familia.id"> {{ familia.familia }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md-6 text-left">
                        <label for="pdfProducto">Archivo PDF:</label>
                        <input type="file" accept="application/pdf" (change)="pdfInput($event)" id="pdfProducto" class="form-control-file" required>
                    </div>
                    <!-- <div class="form-group col-12 col-md-4 col-lg-4 text-center">
                        <div class="mt-3">
                            <input ngModel="Activo" name="Activo" type="checkbox" id="Activo" required class="form-check-input">
                            <label for="Activo" class="form-check-label">&nbsp;Activo</label>
                        </div>
                    </div> -->
                    <div class="form-group col-12 text-left">
                        <label for="DetalleOferta">Detalle de oferta:</label>
                        <textarea ngModel="DetalleOferta" name="DetalleOferta" name="DetalleOferta" class="form-control" placeholder=" " rows="6" style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px; resize: none;" required></textarea>
                    </div>
                  
                    <div class="col-12">
                        <button type="submit" class="mr-2"> Guardar </button>
                        <button class="ml-2 redBtn" (click)="cancel()"> Cancelar</button>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p>¿La información que ingreso es correcta?</p>
            <button class="btn-confirmar mr-2" (click)="closeok()">Aceptar</button>
            <button class="ml-2 redBtn" (click)="closefail()"> Cancelar</button>
        </div>

	</div>

</div>